import React from "react";
import { fr } from "@/locales/fr";

export const FounderQuoteFR = () => {
  const t = fr.founderQuote;
  return (
    <section
      className="bg-cream w-full px-6 sm:px-10 lg:px-16 py-28 sm:py-36 lg:py-44"
      data-testid="founder-quote-section-fr"
    >
      <figure className="max-w-prose3 mx-auto text-center">
        <div
          className="display-serif text-gold leading-none mb-4"
          style={{ fontSize: "6rem" }}
          aria-hidden="true"
        >
          &laquo;
        </div>

        <blockquote
          className="display-serif text-nearblack text-2xl sm:text-3xl lg:text-4xl leading-[1.25] italic font-light mb-10"
          data-testid="founder-quote-text-fr"
        >
          {t.text}
        </blockquote>

        <div className="w-12 h-px bg-gold mx-auto mb-6" />

        <figcaption
          className="font-ui text-sm tracking-wide text-nearblack/65"
          data-testid="founder-quote-attribution-fr"
        >
          <span className="text-nearblack">{t.name}</span>
          <span className="mx-2 text-nearblack/40">·</span>
          <span className="italic">{t.role}</span>
        </figcaption>
      </figure>
    </section>
  );
};

export default FounderQuoteFR;
